export const FETCH_ORDER_STATUSES = "FETCH_ORDER_STATUSES";
export const FETCH_ORDER_STATUS = "FETCH_ORDER_STATUS";
export const CREATE_ORDER_STATUS = "CREATE_ORDER_STATUS";
export const UPDATE_ORDER_STATUS = "UPDATE_ORDER_STATUS";
export const DELETE_ORDER_STATUS = "DELETE_ORDER_STATUS";

export function fetchOrderStatuses(params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_ORDER_STATUSES,
    auth: true,
    payload: {
      url: "superuser/order-status",
      method: "GET",
      params
    }
  };
}

export function fetchOrderStatus(id, params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_ORDER_STATUS,
    auth: true,
    payload: {
      url: `superuser/order-status/${id}`,
      method: "GET",
      params
    }
  };
}

export function createOrderStatus(data = {}) {
  return {
    type: CREATE_ORDER_STATUS,
    auth: true,
    payload: {
      url: "superuser/order-status",
      method: "POST",
      data
    }
  };
}

export function updateOrderStatus(id, data = {}) {
  return {
    type: UPDATE_ORDER_STATUS,
    auth: true,
    payload: {
      url: `superuser/order-status/${id}`,
      method: "PUT",
      data
    }
  };
}

export function deleteOrderStatus(id, data = {}) {
  return {
    type: DELETE_ORDER_STATUS,
    auth: true,
    payload: {
      url: `superuser/order-status/${id}`,
      method: "DELETE",
      data
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/orderStatus.js